module.exports = __webpack_public_path__ + "static/img/performance05.6d0ee3b6.jpg";